<nav class="nav-menu">
    <button class="menu-btn focus-element"><span class="focus--content" tabindex="-1"><span class="burger-lines"></span></span></button>
    <ul class="nav-menu-list">
        <li *ngFor="let route of routes; let i = index" class="nav-menu-list--item" routerLinkActive="active">
            <a *ngIf="route.isAuthorized" class="focus-element" [routerLink]="route.route" [queryParams]="route.queryParams" [ngClass]="{'active': route.isClicked}" (click)="onClick(i)"><span class="focus--content" tabindex="-1"><svg class="nav-menu--ic"><use attr.xlink:href="{{route.svg}}" attr.href="{{route.svg}}"></use></svg> {{route.name}}</span></a>
        </li>
    </ul>
    <p style="color:white">Version: {{version}}</p>
</nav>
